<template>
  <v-container
    class="ma-0 pa-0"
  >
    <v-row
      class="ma-0 pa-0"
    >
      <!--結果表示欄-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-list
            v-for="(item, index) in dspList"
            :key="`${index}-${item}`"
            class="ma-1 pa-0"
            min-height="25px"
            v-text="item"
          />
        </v-card>
      </v-col>
      <!--ここまでー結果表示欄-->
      <v-col
        cols="6"
        class="ma-0 pa-1"
      >
        <v-card
          class="ma-0 pa-0 overflow-y-auto"
          style="height:87vh;"
        >
          <v-tabs
            v-model="editTabs"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
            fixed-tabs
            class="fixed-bar"
          >
            <v-tabs-slider />
            <v-tab :href="'#edit-type-1'">
              確認
            </v-tab>
            <v-tab :href="'#edit-type-2'">
              編集
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="editTabs">
            <v-tab-item
              :value="'edit-type-1'"
              class="ma-0 pa-2"
            >
              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                一般
              </v-chip>

              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="getInformation()"
              >
                一般情報
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="sumitsukiList()"
              >
                墨付き括弧
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="fugouList()"
              >
                符号
              </v-btn>

              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                請求項
              </v-chip>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="dependantCheck()"
              >
                従属請求項
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="allClaimsSubRelation()"
              >
                従属パターン
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="zenkiList()"
              >
                前記に係る単語
              </v-btn>
              <v-switch
                v-model="isZenkiOKDsp"
                hide-details="false"
                class="ma-0 pa-1"
                :label="`${isZenkiOKDsp ? 'OK表示' : 'OK非表示' }`"
              />
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="zenkiCheck()"
              >
                前記チェック
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="excelPaste()"
              >
                Excel転載用請求項
              </v-btn>
            </v-tab-item>
            <v-tab-item
              :value="'edit-type-2'"
              class="ma-0 pa-2"
            >
              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                書式
              </v-chip>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="updateNumber(0)"
              >
                段落番号の更新（日本）
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="updateNumber(1)"
              >
                段落番号の更新（外国用）
              </v-btn>
              <v-btn
                block
                small
                outlined
                color="primary"
                class="mb-3 pa-0"
                @click="insertBracket()"
              >
                改行位置へ段落番号挿入
              </v-btn>
              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                図・数式
              </v-chip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-file-input
                    model="pathImage"
                    accept="image/*"
                    truncate-length="30"
                    label="カーソル位置に挿入"
                    v-bind="attrs"
                    v-on="on"
                    @change="selectedImage"
                  />
                </template>
                <span>※半角英数字の画像データをHTMLと同フォルダに配置</span>
              </v-tooltip>
              <v-chip
                class="ma-1"
                color="success"
                outlined
              >
                <v-icon left>
                  mdi-information-outline
                </v-icon>
                その他
              </v-chip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    small
                    outlined
                    color="primary"
                    class="mb-3 pa-0"
                    v-bind="attrs"
                    v-on="on"
                    @click="eliminateNewline()"
                  >
                    不要改行削除※pdf/拒絶文書等
                  </v-btn>
                </template>
                <span>以下の文字数ないの改行を削除します。</span>
              </v-tooltip>
              <v-row>
                <v-col
                  cols="5"
                  class="ma-0 pa-0 pl-4 pt-2"
                  style="font-size: 12px;"
                >
                  削除対象の改行<br>文頭から：
                </v-col>
                <v-col
                  cols="3"
                  class="ma-0 pa-0 pt-1 pl-0"
                >
                  <v-text-field
                    v-model="characterNumFrom"
                    label="文字以上"
                  />
                </v-col>
                <v-col
                  cols="3"
                  class="ma-0 pa-0 pt-1 pr-0"
                >
                  <v-text-field
                    v-model="characterNumTo"
                    label="文字未満"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import culCharacter from '../../../store/modules/culCharacter'
  import culIndex from '../../../store/modules/culIndex'
  import culDisplay from '../../../store/modules/culDisplay'

  export default {
    data: () => ({
      editTabs: null,
      dspList: '',
      isZenkiOKDsp: false,
      testapi: 'block',
      characterNumFrom: 33,
      characterNumTo: 37,
      // characterNumTo: { type: ['26', '30', '34', '36', '40', '44', '48', '52'], selected: '40' },
    }),

    methods: {
      updateNumber (foreign = 0) {
        let changeDoc = ''
        if (foreign === 0) {
          const docList = this.$store.state.memNowDoc.replace(/\r?\n/g, '<br>').split(/【[０-９]{4}】/g)
          let num = 0
          for (const pick of docList) {
            num++
            const zeroNum = '0'.repeat((4 - String(num).length))
            if (num !== docList.length) changeDoc = changeDoc + pick + '【' + culCharacter.han2ZenLtrNum(zeroNum + String(num)) + '】'
            else changeDoc = changeDoc + pick
          }
        } else {
          const docList = this.$store.state.memNowDoc.replace(/\r?\n/g, '<br>').split(/\[[0-9]{4}\]/g)
          let num = 0
          for (const pick of docList) {
            num++
            const zeroNum = '0'.repeat((4 - String(num).length))
            if (num !== docList.length) changeDoc = changeDoc + pick + '[' + zeroNum + String(num) + ']'
            else changeDoc = changeDoc + pick
          }
        }
        this.$store.commit('changeEdtorHTML', changeDoc)
      },
      // 大括弧で囲まれたものを抽出
      insertBracket () {
        if (this.$store.state.memNowDoc.match(/\r?\n/g) > 0) return
        let num = 0
        const docList = this.$store.state.memNowDoc.split(/\r?\n/g)
        let changeDoc = ''
        for (var pick of docList) {
          num++
          const zeroNum = '0'.repeat((4 - String(num).length))
          if (num === 1) changeDoc = '【' + culCharacter.han2ZenLtrNum(zeroNum + String(num)) + '】<br>' + pick
          else changeDoc = changeDoc + '<br>【' + culCharacter.han2ZenLtrNum(zeroNum + String(num)) + '】<br>' + pick
        }
        this.$store.commit('changeEdtorHTML', changeDoc)
      },

      async selectedImage (file) {
        const fr = new FileReader()
        fr.readAsDataURL(file)
        this.$store.state.watchImage = file.name
        // データ読み出し
        // fr.addEventListener('load', () => {
        //   this.$store.state.watchImage = fr.result
        // })
      },

      // alternate () {
      //   if (this.$store.state.memNowDoc === '') return
      //   let spDoc = this.$store.state.memNowDoc.split('【書類名】')
      //   spDoc.shift()
      //   spDoc = spDoc.map((value) => { return '【書類名】' + value })
      //   const firtst = spDoc.shift()
      //   spDoc.push(firtst)
      //   this.$store.commit('changeEdtorHTML', spDoc.join('').replace(/\r?\n/g, '<br>'))
      // },

      getInformation () {
        // 情報抽出
        const splitDocNum = this.$store.state.memNowDoc.match(/【[０-９]*】/g)
        // 請求項抽出処理
        let splitDocClaim = this.$store.state.memNowDoc.split(/(?=【)/g)
        splitDocClaim = splitDocClaim.filter((value) => { return /【請求項/.test(value) })
        // 墨付き括弧の削除
        let claimContent = splitDocClaim.pop().split(/【.*】/g).shift()
        claimContent = splitDocClaim.concat(claimContent)
        this.claimdependent = []
        // 表示処理
        const infoDsp = ['段落数:　' + splitDocNum.length, '請求項数:　' + claimContent.length]
        this.dspList = infoDsp
      },

      dependantCheck () {
        const dependantList = this.dependantList()
        const dependantDsp = []
        for (let i = 0; i < dependantList.length; i++) {
          dependantDsp.push('請求項' + (i + 1).toString() + '：' + JSON.parse(JSON.stringify(dependantList[i])))
        }
        this.dspList = dependantDsp
      },
      // 請求項の従属関係のリストを作成
      dependantList () {
        // 請求項の抽出。0は全部
        const claimContent = this.pickClaim(0)
        const dependant = []
        let temp = []
        // 従属関係の抽出
        for (var i = 0; i < claimContent.length; i++) {
          // いずれか１項というケースを取り除き、従属に関係する箇所のみ抽出
          let tempclaim = claimContent[i].replace('１項', '').match(/請求項[０-９]+.*記載/g)
          if (tempclaim !== null) tempclaim = tempclaim[0].match(/[０-９]+/g)
          if (tempclaim === null) temp = ''
          else if (tempclaim.length === 1) {
            temp = parseInt(culCharacter.zen2HanLtrNum(tempclaim[0].match(/[０-９]+/g)[0])).toString()
          } else if (tempclaim.length === 2) {
            const firstNum = parseInt(culCharacter.zen2HanLtrNum(tempclaim[0].match(/[０-９]+/g)[0]))
            const secondNum = parseInt(culCharacter.zen2HanLtrNum(tempclaim[1].match(/[０-９]+/g)[0]))
            if (/又は|または/.test(claimContent[i].match(/(請求項[０-９]+).*([０-９]+)/g)[0])) temp = [firstNum, secondNum].join(', ')
            else if (/から|乃至/.test(claimContent[i].match(/(請求項[０-９]+).*([０-９]+)/g)[0])) temp = [...Array(secondNum - firstNum + 1)].map((_, i) => i + firstNum).join(', ')
          } else if (tempclaim.length > 2) {
            temp = tempclaim.map(value => parseInt(culCharacter.zen2HanLtrNum(value.replace(/[^０-９]/g, '')))).join(', ')
          } else { temp = '' }
          dependant.push(temp.split(','))
        }
        // 配列の中身が文字列なので全て数字に変換して返す
        return dependant.map((value) => { return value.map(Number) })
      },

      allSubList (listVlue) {
        // オブジェクトの箱を用意。請求項１は独立請求項とし、その他は空の配列で初期化
        var objectList = { 1: [[0]] }
        for (let i = 2; i <= listVlue.length; i++) { objectList[i] = [] }
        for (let i = 2; i <= listVlue.length; i++) {
          // 独立請求項の場合
          if (listVlue[i - 1].length === 1 && listVlue[i - 1][0] === 0) {
            objectList[i] = [[0]]
          // その他の場合
          } else {
            for (const pick of listVlue[i - 1]) {
              // 従属先の従属一覧を入手し、情報を追加してオブジェクトに追加
              objectList[i] = objectList[i].concat(objectList[pick].map((value) => { return value.concat(pick) }))
            }
          }
        }
        return objectList
      },

      allClaimsSubRelation () {
        const tempList = this.dependantList()
        const allsubordinationObj = this.allSubList(tempList)
        let dspSubList = []
        for (let i = 1; i <= tempList.length; i++) {
          dspSubList.push('◆請求項' + (i).toString())
          dspSubList.push(...allsubordinationObj[i])
        }
        dspSubList = dspSubList.map((value) => {
          if (Array.isArray(value) === true) {
            value.shift()
            return value.join('-')
          } else return value
        })
        this.dspList = dspSubList
      },

      zenkiList () {
        const dependantList = this.dependantList()
        const zenkiResult = []
        // 従属リストに基づき請求項１からチェック
        for (var claimnum = 0; claimnum < dependantList.length; claimnum++) {
          // 対象の請求項のみ形態素解析し、名詞と接頭詞のインデックスの収集
          this.$store.commit('partAnalysis/analyseDoc', this.pickClaim(claimnum + 1))
          let checkIndex = culIndex.getCheckIndexList(['名詞', '接頭詞'], [], this.$store.state.partAnalysis.resultSurf.pos1, this.$store.state.partAnalysis.resultSurf.pos2)
          // 前記が含まれる連続したインデックスの収集し名詞リストを作成（正確には名詞or接頭詞リスト）
          checkIndex = culIndex.getSchIndexOnly(this.$store.state.partAnalysis.resultSurf.surf, checkIndex, '前記')
          const noneList = culDisplay.getContPosDocList(checkIndex, this.$store.state.partAnalysis.resultSurf.surf).map(value => value.replace('前記', ''))
          zenkiResult.push('◆請求項' + (claimnum + 1).toString())
          zenkiResult.push(...noneList)
        }
        this.dspList = zenkiResult
      },

      zenkiCheck () {
        const dependantList = this.dependantList()
        const zenkiResult = ['※前記に連続した名詞と接頭詞を従属ツリー毎に判定']
        let noneAll = []
        // 従属リストに基づき請求項１からチェック
        for (var claimnum = 0; claimnum < dependantList.length; claimnum++) {
          // 対象の請求項のみ形態素解析し、名詞と接頭詞のインデックスの収集
          this.$store.commit('partAnalysis/analyseDoc', this.pickClaim(claimnum + 1))
          let checkIndex = culIndex.getCheckIndexList(['名詞', '接頭詞'], [], this.$store.state.partAnalysis.resultSurf.pos1, this.$store.state.partAnalysis.resultSurf.pos2)
          // 前記が含まれる連続したインデックスの収集し名詞リストを作成（正確には名詞or接頭詞リスト）
          checkIndex = culIndex.getSchIndexOnly(this.$store.state.partAnalysis.resultSurf.surf, checkIndex, '前記')
          const noneList = culDisplay.getContPosDocList(checkIndex, this.$store.state.partAnalysis.resultSurf.surf).map(value => value.replace('前記', ''))
          noneAll = noneAll.concat(noneList)
          // 該当請求項の従属パターン取得
          const subListNum = this.allSubList(dependantList)[claimnum + 1]
          // console.log(subListNum)
          // 該当請求項の従属パターンそれぞれの文章リストを作成。該当請求項も最後に追加
          const subListSentence = subListNum.map((value) => {
            // console.log(value)
            const composition = value.map((value) => {
              // console.log(value)
              if (value === 0) return ''
              return this.pickClaim(value)
            }).join('') + this.pickClaim(claimnum + 1)
            // console.log(composition)
            return composition
          })
          // 結果の請求項のラベル作成
          zenkiResult.push('◆請求項' + (claimnum + 1).toString())
          // 名詞リストを参照して前記の前に前記なしが存在するかを判定
          for (var i = 0; i < subListSentence.length; i++) {
            zenkiResult.push('従属先：' + subListNum[i].slice(1).join('-'))
            for (var pick of noneList) {
              if (subListSentence[i].indexOf(pick) < subListSentence[i].indexOf('前記' + pick)) {
                if (this.isZenkiOKDsp === true) zenkiResult.push('　' + pick + ': OK')
              } else { zenkiResult.push('　' + pick + ': NG') }
            }
          }
        }
        // 一覧表示
        this.dspList = zenkiResult
        noneAll = culIndex.deduplicate(noneAll).sort().filter(v => v)
        // 文章への色追加
        const colorCont = (this.$store.state.darkTheme === true) ? '<span style="background-color: #0000CC;">$&</span>' : '<span style="background-color: #CCFFCC;">$&</span>'
        const colorZenki = (this.$store.state.darkTheme === true) ? '<span style="background-color: #6a5acd;">$&</span>' : '<span style="background-color: #00ffff;">$&</span>'
        let changeDoc = this.$store.state.memNowHTML.replace(new RegExp('前記', 'g'), colorZenki)
        for (pick of noneAll) { changeDoc = changeDoc.replace(new RegExp(pick, 'g'), colorCont) }
        this.$store.commit('changeEdtorHTML', changeDoc)
      },

      fugouList () {
        this.$store.commit('partAnalysis/analyseDoc', this.$store.state.memNowDoc.replace(/【[^【】]*】/g, ''))
        const checkIndex = culIndex.getCheckIndexList(['名詞'], [], this.$store.state.partAnalysis.resultSurf.pos1, this.$store.state.partAnalysis.resultSurf.pos2)
        // 表示処理
        let noneList = culDisplay.getContPosDocList(checkIndex, this.$store.state.partAnalysis.resultSurf.surf).map(value => value.replace('前記', ''))
        noneList = noneList.filter((word) => { return /[^０-９]+[０-９]/.test(word) })
        this.dspList = noneList
      },

      sumitsukiList () {
        const splitDocPar = this.$store.state.memNowDoc.match(/【[^０-９][^【】]*】/g)
        this.dspList = splitDocPar
      },

      pickClaim (argnum = 0) {
        let splitDocClaim = this.$store.state.memNowDoc.split(/(?=【)/g)
        splitDocClaim = splitDocClaim.filter((value) => { return /【請求項/.test(value) }).map((value) => { return value.replace(/【請求項[０-９]*】/g, '') })
        if (argnum === 0) return splitDocClaim
        else return splitDocClaim[argnum - 1]
      },

      excelPaste () {
        let splitDocClaim = this.$store.state.memNowDoc.split(/(?=【)/g)
        splitDocClaim = splitDocClaim.filter((value) => { return /【請求項/.test(value) })
        splitDocClaim = splitDocClaim.map((value) => {
          return '=' + '"' + value.replace(/\n$|\r\n$|\r$/g, '').replace(/\r?\n/g, '"&char(10)&"') + '"'
        })
        this.dspList = splitDocClaim
      },

      eliminateNewline () {
        let splitNewline = this.$store.state.memNowDoc.split(/\n|\r\n|\r/g)
        splitNewline = splitNewline.map((value, index, array) => {
          if (index !== array.length - 1) {
            if (/^\s/.test(array[index + 1]) === true) return value + '<br>'
          }
          if (value.length <= this.characterNumTo && value.length > this.characterNumFrom && !/\s$/.test(value) && !/。$/.test(value)) return value
          else return value + '<br>'
        })
        this.$store.commit('changeEdtorHTML', splitNewline.join(''))
      },
    },
  }
</script>

<style>
.fixed-bar {
    position: sticky;
    position: -webkit-sticky; /* for Safari */
    top: 0em;
    z-index: 1;
}
</style>
